import React, { useState } from "react";
import Header from "../Header/Header";
import Navbar from "../Header/Navbar";
import AccountSidebar from "./AccountSidebar";
import { Link } from "react-router-dom";
const BetHistoryComponent = () => {
  const [activeButton, setActiveButton] = useState(" Current Bets");

  function handleButtonClick(button) {
    setActiveButton(button);
  }


  const navItems = [
    { name: 'Current Bets', path: '/current-bets' },
    { name: 'Bet History', path: '/bet-history' },
    { name: 'Profit & Loss', path: '/profit-loss' },
   
  ];
  
  const navSubItems = [
    { name: 'Exchange', path: '/exchange' },
    { name: 'Fancy Bet', path: '/bet-history' },
    { name: 'Fancy1 Bet', path: '/bet-history' },
    { name: 'Sportbook', path: '/bet-history' },
    { name: 'Casino Bet', path: '/bet-history' },
    { name: 'Toss Bet', path: '/bet-history' },
    { name: 'Book Maker', path: '/bet-history' },
    { name: 'Premium', path: '/bet-history' },
   
  ];
  

  return (
    <div>
      <Header />
      <Navbar />
      <div className="account_main  bg-[#f0ece1]   mt-1 flex">
        <AccountSidebar />
        <div className="balance_overview w-[70%]  mt-2   ml-4 ">
          <h2 className="font-bold mb-2">My Bets</h2>
         
         
          {navItems.map((item) => (
  <Link
    key={item.path}
    to={item.path}
    className={`inplay_button ${activeButton === item.path.slice(1) ? 'active' : ''}`}
    onClick={() => handleButtonClick(item.path.slice(1))}
    style={{
      backgroundColor: activeButton === item.path.slice(1) ? '#3b5160' : '',
      color: activeButton === item.path.slice(1) ? 'white' : '',
    }}
  >
    {item.name}
  </Link>
))}
           <div className="mt-3">
           {navSubItems.map((item) => (
  <Link
    key={item.path}
    to={item.path}
    className={`inplay_button ${activeButton === item.path.slice(1) ? 'active' : ''}`}
    onClick={() => handleButtonClick(item.path.slice(1))}
    style={{
      backgroundColor: activeButton === item.path.slice(1) ? '#3b5160' : '',
      color: activeButton === item.path.slice(1) ? 'white' : '',
    }}
  >
    {item.name}
  </Link>
))}

           </div>
           
           
           

         
          <div
            className="bg-[#dcf0ff]   mt-3 px-2 py-4
          "
          >
            <div className="flex mb-2">
              <p className="">Bet Status:</p>
              <select
                name=""
                id=""
                className="mx-2 px-2 border-black border-1 "
              >
                <option value="">settled</option>
              </select>
              <p className="text-[12px]">Period</p>
              <input
                type="date"
                className="mx-2 px-2 border-black border-1 "
                id="birthday"
                name="birthday"
              ></input>
              <input type="text" className="w-[60px]" placeholder="9:00" />
              <p className="">To</p>
              <input
                type="date"
                className="mx-2 px-2 border-black border-1 "
              ></input>
              <input type="text" className="w-[60px]" placeholder="9:00" />
            </div>
            <button
              className="text-[12px]  border-black border-1  rounded px-3 py-1 mt-2 font-medium
              bg-[#fff]
          "
            >
              Just For Today
            </button>
            <button
              className="text-[12px]  border-black border-1  py-1 mx-3 rounded px-3 mt-2 font-medium
              bg-[#fff]
          "
            >
              Just For Today
            </button>
            <button
              className="text-[12px]  border-black border-1  py-1 mx-3 rounded px-3 mt-2 font-bold
              bg-[#fff429]
          "
            >
              Get History
            </button>
          </div>
          <div className="p mt-3">
            <h2 className="text-[12px]">
              Betting History enables you to review the bets you have placed.
            </h2>
            <h2 className="text-[12px]">
              Specify the time period during which your bets were placed, the
              type of markets on which the bets were placed, and the sport.
            </h2>
            <h2 className="text-[12px]">
              Specify the time period during which your bets were placed, the
              type of markets on which the bets were placed, and the sport.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetHistoryComponent;
